import { Tag } from './Tag';
import mySchoolsIcon from '@/assets/my_schools.svg';

export const NewTag = () => <Tag variant="new">New</Tag>;
export const StartDateTag = () => <Tag variant="startDate">Start</Tag>;
export const ExpiredTag = () => <Tag variant="expired">Expired</Tag>;
export const DeadlineTag = () => <Tag variant="deadline">Deadline</Tag>;
export const CommunityTag = () => <Tag variant='community'>Community</Tag>;
export const ExtendedCommunityTag = () => <Tag variant='community'>Extended Community</Tag>;

export const SchoolTag = () => (
  <Tag
    leftIcon={
      <img src={mySchoolsIcon} alt="School icon" width="16px" height="16px" />
    }
    variant='timeline'
  >
      School
  </Tag>
);



